import * as React from 'react';

export interface AsterixProps {
  showAsterix?:boolean;
}

/**
 * Adds an asterix (*) character by adding a CSS class name of children's class name.
 */
export default class Asterix extends React.Component<AsterixProps> {

  constructor(props: AsterixProps) {
    super(props);
  }

  public render() {
    const { children, showAsterix } = this.props;
    return (
      <React.Fragment>
        { 
          showAsterix 
          ? 
          React.Children.map(children, (child: React.ReactElement<any>) => {
            let className = child.props.className === undefined ? '' : child.props.className + ' ';
            return React.cloneElement(child, { className: className + 'add-asterix' });
          })
          : 
          children
        }
      </React.Fragment>
    );
  }
}
